import { Subscribe } from './types';

/**
 * Процесс сбора подписок источников
 * 1. Начинает выполняться функция start
 * 2. isDataSourceCollecting выставляется в true
 * 3. Каждый dataSource записывает в переменную currentReactionDataSources функцию Subscribe,
 *    которую нужно вызвать для создания подписки.
 *    В эту функцию Subscribe передается notify - колбэк, который dataSource будет вызывать при изменениях
 * 4. Эта функция Subscribe возвращает unsubscribe - функцию, которую нужно вызвать для отмены подписок.
 * 5. По завершению start или при переходе к асинхронному коду isDataSourceCollecting выставляется в false
 */
export let currentReactionDataSources: Set<Subscribe> = new Set();

/**
 * Переменная имеет значение true во время выполнения функции-генератора data реакций.
 * Может быть использована при создании источников данных
 */
let isDataSourceCollecting = false;

/**
 * Получить isDataSourceCollecting
 *
 * @returns isDataSourceCollecting - true во время выполнения функции-генератора data реакций
 */
export function getIsDataSourceCollecting() {
    return isDataSourceCollecting;
}

/**
 * Установить isDataSourceCollecting
 *
 * @internal
 * @param newValue - значение для установки в isDataSourceCollecting
 */
export function setIsDataSourceCollecting(newValue: boolean) {
    isDataSourceCollecting = newValue;
}
